'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from 'next-intl';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useCommentContext } from '@/contexts/comment.context';
import { useCommentsContext } from '@/contexts/comments.context';
import { useCreatePostComment } from '@/hooks/queries/comment.query';
import { useSession } from '@/lib/auth-client';
import { CommentEditor } from './comment-editor';
import { UnauthenticatedOverlay } from './unauthenticated-overlay';
export function CommentReply() {
  const $ = _c(55);
  const [content, setContent] = useState("");
  const {
    data: session
  } = useSession();
  const {
    comment,
    setIsReplying
  } = useCommentContext();
  const {
    slug
  } = useCommentsContext();
  const locale = useLocale();
  const t = useTranslations();
  let t0;
  if ($[0] !== slug) {
    t0 = {
      slug
    };
    $[0] = slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== setIsReplying || $[3] !== t) {
    t1 = () => {
      setIsReplying(false);
      toast.success(t("success.reply-posted"), {
        testId: "comment-reply-posted-toast"
      });
    };
    $[2] = setIsReplying;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    mutate: createReply,
    isPending: isCreating
  } = useCreatePostComment(t0, t1);
  let t2;
  if ($[5] !== comment || $[6] !== content || $[7] !== createReply || $[8] !== isCreating || $[9] !== locale || $[10] !== slug || $[11] !== t) {
    t2 = function submitCommentReply(e) {
      e?.preventDefault();
      if (isCreating) {
        return;
      }
      if (!content.trim()) {
        toast.error(t("error.reply-cannot-be-empty"));
        return;
      }
      createReply({
        slug,
        content: content.trim(),
        locale,
        parentId: comment.id
      });
    };
    $[5] = comment;
    $[6] = content;
    $[7] = createReply;
    $[8] = isCreating;
    $[9] = locale;
    $[10] = slug;
    $[11] = t;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const submitCommentReply = t2;
  const isAuthenticated = session !== null;
  const disabled = !isAuthenticated || isCreating;
  let t3;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => {
      setContent(e_0.target.value);
    };
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== setIsReplying) {
    t4 = () => {
      setIsReplying(false);
    };
    $[14] = setIsReplying;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t) {
    t5 = t("blog.comments.reply-to-comment");
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== content || $[19] !== disabled || $[20] !== submitCommentReply || $[21] !== t4 || $[22] !== t5) {
    t6 = <CommentEditor value={content} onChange={t3} onModEnter={submitCommentReply} onEscape={t4} placeholder={t5} disabled={disabled} autoFocus={true} data-testid="comment-textarea-reply" />;
    $[18] = content;
    $[19] = disabled;
    $[20] = submitCommentReply;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== isAuthenticated) {
    t7 = isAuthenticated ? null : <UnauthenticatedOverlay />;
    $[24] = isAuthenticated;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t6 || $[27] !== t7) {
    t8 = <div className="relative">{t6}{t7}</div>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== content || $[30] !== disabled) {
    t9 = disabled || !content.trim();
    $[29] = content;
    $[30] = disabled;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== content || $[33] !== disabled) {
    t10 = disabled || !content.trim();
    $[32] = content;
    $[33] = disabled;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t) {
    t11 = t("blog.comments.reply");
    $[35] = t;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t9) {
    t12 = <Button variant="secondary" size="sm" type="submit" disabled={t9} aria-disabled={t10} data-testid="comment-submit-reply-button">{t11}</Button>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t9;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== setIsReplying) {
    t13 = () => {
      setIsReplying(false);
    };
    $[41] = setIsReplying;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== t) {
    t14 = t("common.cancel");
    $[43] = t;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t13 || $[46] !== t14) {
    t15 = <Button variant="secondary" size="sm" onClick={t13}>{t14}</Button>;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== t12 || $[49] !== t15) {
    t16 = <div className="mt-2 space-x-1">{t12}{t15}</div>;
    $[48] = t12;
    $[49] = t15;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== submitCommentReply || $[52] !== t16 || $[53] !== t8) {
    t17 = <form onSubmit={submitCommentReply}>{t8}{t16}</form>;
    $[51] = submitCommentReply;
    $[52] = t16;
    $[53] = t8;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  return t17;
}